import { Icon, Icons } from "@phoenix/components/core/icon";

export const FieldSuccessIcon = () => {
  return (
    <Icon color="success" className="field__icon" svg={<Icons.Checkmark />} />
  );
};
